module.exports = __webpack_public_path__ + "img/depmap_svg_V176.5fc01060.svg";